// Regex
export const VALID_EMAIL_REGEX = /\S+@\S+\.\S+/;
export const VALID_PASSWORD_REGEX =
	/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

// Auth
export const INVALID_CREDENTIALS = 'Invalid credentials';
export const INVALID_EMAIL = 'Invalid email';
export const INVALID_PASSWORD =
	'Invalid password. Password must contain a minimum of 8 characters and include at least one uppercase letter, one lowercase letter, one digit and one special character';
export const PASSWORDS_DO_NOT_MATCH = 'Passwords must match';

export const WRONG_EMAIL = 'Wrong email';
